<template>
  <div class="text-center">
    <v-bottom-sheet inset max-width="400px" v-model="sheet" persistent>
      <!-- <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="success btn-titulo ml-2 mt-1"
          height="40px"
          dark
          v-bind="attrs"
          v-on="on"
          >Gerar
        </v-btn>
      </template> -->
      <v-card tile>
        <v-toolbar color="#042333" dark>
          <v-btn icon dark @click="sheet = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Downloads</v-toolbar-title>
        </v-toolbar>
        <v-progress-linear
          :value="100"
          class="my-0"
          height="3"
        ></v-progress-linear>
        <v-list class="pb-4 pt-0">
          <template v-for="(i, k) in itens">
            <v-list-item :key="k" :href="i.url" ref="item" :target="i.target">
              <v-list-item-content>
                <v-list-item-title>{{ `${i.titulo}_${i.data_emissao.substring(0, 10).replace(/[/]/g, '_')}_${i.parcela}` }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-btn icon>
                  <v-icon>mdi-cloud-download</v-icon>
                </v-btn>
              </v-list-item-icon>
            </v-list-item>
            <!-- <v-divider :key="k" /> -->
          </template>
        </v-list>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters("relatorio", ["itens"]),
    sheet: {
      get() {
        return this.$store.state.relatorio.sheet;
      },
      set(val) {
        this.$store.commit("relatorio/setSheet", val);
      },
    },
  }
};
</script>
